import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Steps, { Step } from 'rc-steps';
import { getRequest } from '../../../requestUtils';
import './SideNavStepProgressBar.scss';
import chatLogo from '../../../../assets/images/clora-chat-logo.svg';
import { analyticsTrack } from '../../../analyticsUtils';
var setStepStatus = function setStepStatus(currentStep, step, completed) {
  if (currentStep === step) {
    return 'process';
  }
  return completed ? 'finish' : 'wait';
};
var SideNavStepProgressBar = /*#__PURE__*/function (_Component) {
  function SideNavStepProgressBar(props) {
    var _this;
    _classCallCheck(this, SideNavStepProgressBar);
    _this = _callSuper(this, SideNavStepProgressBar, [props]);
    _this.state = {
      onboardingMenu: [],
      currentStep: null
    };
    _this.handleMenuClick = _this.handleMenuClick.bind(_this);
    _this.getOnboardingMenu = _this.getOnboardingMenu.bind(_this);
    return _this;
  }
  _inherits(SideNavStepProgressBar, _Component);
  return _createClass(SideNavStepProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getOnboardingMenu();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        updateMenu = _this$props.updateMenu,
        handleMenuUpdate = _this$props.handleMenuUpdate;
      if (updateMenu) {
        this.getOnboardingMenu();
        handleMenuUpdate(false);
      }
    }
  }, {
    key: "getOnboardingMenu",
    value: function getOnboardingMenu() {
      var _this2 = this;
      var userId = this.props.userId;
      getRequest("/users/".concat(userId, "/onboarding_menu")).then(function (_ref) {
        var data = _ref.data;
        _this2.setState({
          onboardingMenu: data,
          currentStep: data.find(function (item) {
            return item.status === 'process';
          })
        });
      });
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(currentStep) {
      var state = currentStep === 0 ? 0 : 1;
      var onboardingMenu = this.state.onboardingMenu;
      var title = onboardingMenu[currentStep].title;
      analyticsTrack('Using Progress bar to advance', {
        location: 'Onboarding Flow',
        step: title
      });
      this.props.handleMenuClick(state, currentStep);
    }
  }, {
    key: "renderStep",
    value: function renderStep(stepIndex, title, status, description, disabled, step) {
      return /*#__PURE__*/React.createElement(Step, {
        stepIndex: stepIndex,
        title: title,
        description: description,
        status: setStepStatus(step, stepIndex, status),
        onStepClick: this.handleMenuClick
      });
    }
  }, {
    key: "renderOnboardingMenu",
    value: function renderOnboardingMenu() {
      var _this3 = this;
      var _this$props2 = this.props,
        step = _this$props2.step,
        uploadingResume = _this$props2.uploadingResume;
      var onboardingMenu = this.state.onboardingMenu;
      return /*#__PURE__*/React.createElement(Steps, {
        direction: "vertical",
        current: step || 0
      }, onboardingMenu.map(function (menu) {
        return _this3.renderStep(menu.stepIndex, menu.title, menu.completed, menu.description, uploadingResume, step);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "side-nav-container"
      }, this.renderOnboardingMenu(), /*#__PURE__*/React.createElement("div", {
        className: "message-cta"
      }, /*#__PURE__*/React.createElement("img", {
        src: chatLogo,
        alt: "ligh bulb"
      }), /*#__PURE__*/React.createElement("div", {
        className: "message-text"
      }, /*#__PURE__*/React.createElement("div", {
        className: "small-text"
      }, "Need help?"), /*#__PURE__*/React.createElement("div", {
        className: "large-text"
      }, "Chat with us!"))));
    }
  }]);
}(Component);
SideNavStepProgressBar.propTypes = {
  step: PropTypes.number.isRequired,
  userId: PropTypes.string.isRequired,
  updateMenu: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
  uploadingResume: PropTypes.bool
};
SideNavStepProgressBar.defaultProps = {
  uploadingResume: false
};
export default SideNavStepProgressBar;